<template>
  <div class="func-modify common-page">
    <!-- 面包屑 -->
    <a-breadcrumb>
      <a-breadcrumb-item>功能管理</a-breadcrumb-item>
      <a-breadcrumb-item>修改</a-breadcrumb-item>
    </a-breadcrumb>

    <section class="common-box">
      <div class="common-box-title">修改</div>
      <div class="common-box-body">
        <a-form :form="form" style="width: 600px">
          <a-form-item label="功能名称" v-bind="formItemLayout">
            <a-input
              placeholder="请输入功能名称"
              maxlength="64"
              v-decorator="[
                'name',
                {
                  rules: [
                    {
                      required: true,
                      message: '请输入功能名称',
                      whitespace: true,
                    },
                  ],
                },
              ]"
            />
          </a-form-item>

          <a-form-item label="描述" v-bind="formItemLayout">
            <a-input
              placeholder="请输入描述"
              maxlength="64"
              v-decorator="[
                'description',
                {
                  rules: [
                    {
                      required: true,
                      message: '请输入描述',
                      whitespace: true,
                    },
                  ],
                },
              ]"
            />
          </a-form-item>

          <a-form-item label="英文描述" v-bind="formItemLayout">
            <a-input
              placeholder="请输入英文描述"
              maxlength="64"
              v-decorator="[
                'description_en',
                {
                  rules: [
                    {
                      required: true,
                      message: '请输入英文描述',
                      whitespace: true,
                    },
                  ],
                },
              ]"
            />
          </a-form-item>

          <a-form-item label="功能code" v-bind="formItemLayout">
            <a-input
              placeholder="请输入功能code"
              maxlength="64"
              v-decorator="[
                'code',
                {
                  rules: [
                    {
                      required: true,
                      message: '请输入功能code',
                      whitespace: true,
                    },
                  ],
                },
              ]"
            />
          </a-form-item>
          <a-form-item label="算法code" v-bind="formItemLayout">
            <a-button
              size="small"
              style="margin-right: 5px"
              @click="addlist"
              type="primary"
              >添加</a-button
            >
            <div class="lists" v-for="(item, index) in lists" :key="index">
              <a-input v-model="item.text" placeholder="请输入算法code" />
              <a-button
                size="small"
                style="margin-right: 5px"
                @click="removelist(index)"
                type="primary"
                >删除</a-button
              >
            </div>
          </a-form-item>
          <a-form-item label :wrapper-col="{ span: 12, offset: 4 }">
            <a-button type="primary" @click="submit" :loading="loading"
              >提交</a-button
            >
          </a-form-item>
        </a-form>
      </div>
    </section>
  </div>
</template>

<script>
import { editFunction, queryFunctions } from "../api/api";

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 4 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 14 },
  },
};

export default {
  name: "func-modify",

  data() {
    return {
      form: this.$form.createForm(this),
      formItemLayout,
      loading: false,
      functions: [],
      func: {},
      lists: [],
    };
  },

  computed: {
    funcID() {
      return parseInt(this.$route.query.funcID);
    },
  },

  created() {
    this.fetchData();
  },

  methods: {
    addlist() {
      this.lists.push({
        text: "",
      });
    },
    removelist(index) {
      this.lists.splice(index, 1);
    },
    submit() {
      this.form.validateFields((err, values) => {
        if (!err) {
          let newlist = [];
          this.lists.map((res) => {
            newlist.push(res.text);
          });
          let ary = newlist;
          var nary = ary.sort();
          for (var i = 0; i < ary.length; i++) {
            if (nary[i] == nary[i + 1]) {
              this.loading = false;
              this.$message.error("算法code重复！");
              return;
            }
          }
          this.loading = true;
          values.id = this.funcID;
          let params = {
            ...values,
            algorithm: newlist.toString(),
          };
          editFunction(params).then((res) => {
            if (res.error.code === 0) {
              this.$message.success("修改成功");
              this.$router.back();
            }
            this.loading = false;
          });
        }
      });
    },

    fetchData() {
      queryFunctions().then((res) => {
        if (res.error.code === 0) {
          this.functions = res.response ? res.response.functions : [];
          this.func = this.functions.find((func) => func.id === this.funcID);
          if (this.func.algorithm) {
            this.lists = [];
            let list = this.func.algorithm.split(",");
            this.lists = list.map((res) => {
              return {
                text: res,
              };
            });
          } else {
            this.lists = [];
          }
          this.initFormValue();
        }
      });
    },

    initFormValue() {
      this.form.setFieldsValue({
        name: this.func.name,
        description: this.func.description,
        description_en: this.func.descriptionEn,
        code: this.func.code,
        algorithm: this.func.algorithm,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.lists {
  display: flex;
  align-items: center;
  margin-top: 20px;
  /deep/ .ant-checkbox-wrapper {
    display: flex;
    align-items: center;
  }
}
.func-modify {
}
</style>